'use client';

import classnames from 'classnames';
import { IoTimeOutline } from 'react-icons/io5';

import { formatTimestamp } from '../../../utils/date';
import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';

import styles from './TimeLimit.module.scss';

type TimeLimitProps = BaseComponentProps & {
  /**
   * The whole duration to show, in seconds. Nothing at all renders no clock, so a caller
   * with no time to report does not have to guard the call site.
   */
  seconds?: number;
  showIcon?: boolean;
};

function TimeLimit({
  style,
  className,
  seconds,
  showIcon = true,
  testId,
}: TimeLimitProps) {
  if (seconds === undefined) {
    return null;
  }

  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <span className={styles['countdown']}>{formatTimestamp(seconds)}</span>
      {showIcon && <Icon icon={<IoTimeOutline />} size="sm" />}
    </div>
  );
}

export { TimeLimit };
